import React from 'react';
import { FiCopy, FiCheck, FiLogOut, FiSidebar, FiUsers } from 'react-icons/fi';
import Avatar from '../../../shared/components/Avatar/Avatar';
import Button from '../../../shared/components/Button/Button';
import styles from './ChatHeader.module.css';

export default function ChatHeader({
  roomId, username, avatarId, copied, connected, participantCount,
  onCopyLink, onLeave, onToggleSidebar
}) {
  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <button
          className={styles.sidebarToggle}
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FiSidebar size={16} />
        </button>
        <Avatar name={username} avatarId={avatarId} size={36} />
        <div className={styles.info}>
          <div className={styles.nameRow}>
            <span className={styles.welcome}>{username}</span>
            <span className={`${styles.statusDot} ${connected ? styles.online : styles.offline}`} />
          </div>
          <span className={styles.roomId}>ROOM: {roomId}</span>
        </div>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.participantBadge}
          onClick={onToggleSidebar}
          aria-label="Show participants"
        >
          <FiUsers size={14} />
          <span>{participantCount}</span>
        </button>

        <Button
          variant="secondary"
          size="small"
          icon={copied ? <FiCheck /> : <FiCopy />}
          onClick={onCopyLink}
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </Button>

        <Button
          variant="ghost"
          size="small"
          icon={<FiLogOut />}
          onClick={onLeave}
        >
          Exit
        </Button>
      </div>
    </div>
  );
}
